import * as React from "react";

import '../styles/MainTypes.css';
import '../styles/Button.css';
import '../styles/Popup.css';

import Dropdown from "./Dropdown";
import AttrTree from "./AttrTree";
import ObjectsTree from "./ObjectsTree";
import Config from "../Config";
import MetamodelStore from "../resources/data/MetamodelStore";
import WordInsertions from "../utils/WordInsertions";
import JsonTreeDataCreator from "../utils/JsonTreeDataCreator";
import ModalLoopObject from "./modals/ModalLoopObject";
import ModalTableAttrs from "./modals/ModalTableAttrs";
import ModalTableObjAttrs from "./modals/ModalTableObjAttrs";
import Loader from "./Loader.jsx";

import tableIcon from '../../assets/icons/table-list.svg'

export default class MainModelTypes extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      aMetaModelTypes: {}, // all types of models
      sSelectedModelTypeId: '', // ID of selected model type
      aSelectedMetaModelTypeData: {}, // selected model type data
      bSelectedSuperModelType: false, // selected model type is super model type (super model type === 'All model types')
      bActive: false,
      loading: false
    };

    this.modals = {
      modelObjLoop: React.createRef(),
      modelAttrs: React.createRef(),
      modelObj: React.createRef()
    };

    Config.getConfig();
  }

  /**
   * Component visible only after setting state variable bActive to true
   */
  setActive = () =>
  {
    this.setState({
      bActive: true
    })
  }

  /**
   * Fetch list of model types
   */
  loadMetaModelTypes = () =>
  {
    try
    {
      var aMetaModelTypes = MetamodelStore.getInstance().getMetaModelTypes();
      if (aMetaModelTypes)
      {
        this.setState({
          aMetaModelTypes: aMetaModelTypes
        });
      }
    } catch (error)
    {
      console.error(error.message);
    }
  }

  /**
   * Fetch data of selected model type
   * @param {String} sID 
   */
  loadMetaModelTypeData = (sID) =>
  {
    try
    {
      var aMetaModelTypeData = MetamodelStore.getInstance().getMetaModelType(sID);
      return aMetaModelTypeData;
    } catch (error)
    {
      console.error(error.message);
      return null;
    }
  }

  /**
   * Change dropdown selection and fetch data of selected model type
   * @param {String} sID 
   */
  refreshModelTypeSelection = (sID) =>
  {
    this.setState({
      loading: true
    });
    setTimeout(() =>
    {
      for (const key in this.state.aMetaModelTypes)
      {
        this.state.aMetaModelTypes[key].selected = false;
      }
      this.state.aMetaModelTypes[sID].selected = true;

      var aMetaModelTypeData = this.loadMetaModelTypeData(sID);

      var bIsSuper = false;
      if (Object.hasOwnProperty.call(aMetaModelTypeData, 'isSuper') && aMetaModelTypeData.isSuper)
      {
        bIsSuper = true;
      }

      this.setState({
        sSelectedModelTypeId: sID,
        aSelectedMetaModelTypeData: aMetaModelTypeData,
        bSelectedSuperModelType: bIsSuper,
        loading: false
      });
    }, 500);
  }

  /**
   * Get data for json tree with model's attributes
   * @param {String} sTopLvlLabel 
   * @param {Boolean} isSuper 
   */
  getJsonTreeModelProp = (sTopLvlLabel, isSuper) =>
  {
    if (Object.hasOwnProperty.call(this.state.aSelectedMetaModelTypeData, 'notebookStructure') || isSuper)
    {
      var aJsonTreeData = (isSuper
        ? JsonTreeDataCreator.superNotebookData('modeltypes', null, true)
        : JsonTreeDataCreator.notebookData(this.state.aSelectedMetaModelTypeData.notebookStructure, true));

      if (sTopLvlLabel)
      {
        return {
          [sTopLvlLabel]: aJsonTreeData
        };
      }
      return aJsonTreeData;
    }
    return null;
  }

  /**
   * Get data for json tree with model's objects
   * @param {String} sTopLvlLabel 
   * @param {Boolean} isSuper 
   */
  getJsonTreeObjProp = (sTopLvlLabel, isSuper) =>
  {
    if (Object.hasOwnProperty.call(this.state.aSelectedMetaModelTypeData, 'classes') || isSuper)
    {
      var aJsonTreeData = (isSuper
        ? JsonTreeDataCreator.superObjectsData(false, true)
        : JsonTreeDataCreator.objectsData(this.state.aSelectedMetaModelTypeData.classes, false, true));

      if (sTopLvlLabel)
      {
        return {
          [sTopLvlLabel]: aJsonTreeData
        };
      }
      return aJsonTreeData;
    }
    return null;
  }

  /**
   * Open/close modal with provided ref
   * @param {String} sModalKey 
   */
  toggleModal = (sModalKey) =>
  {
    if (Object.hasOwnProperty.call(this.modals, sModalKey))
    {
      this.modals[sModalKey].current.toggleModal();
    }
  }

  /**
   * Rendering the component
   */
  render()
  {
    const bLoading = this.state.loading;

    if (!this.state.bActive)
    {
      return (
        <div className="MainTypes">
          <span style={{
            fontWeight: "bold",
            marginTop:"30px",
            marginLeft:"20px",
            fontSize: "12px"
          }}>{Config.strings.dropdowns.loadingSelection}...</span>
        </div>
      )
    }

    /**
     * Get data for json trees
     */
    var aJsonTreeAttrData, aJsonTreeObjectsData, aJsonTreeObjectsDataSimplified = null;
    if (!bLoading)
    {
      aJsonTreeAttrData = this.getJsonTreeModelProp(Config.strings.jsonTree.modelAttributesKey, this.state.bSelectedSuperModelType);
      aJsonTreeObjectsData = this.getJsonTreeObjProp(Config.strings.jsonTree.objectsKey, this.state.bSelectedSuperModelType);
      aJsonTreeObjectsDataSimplified = this.state.bSelectedSuperModelType ? JsonTreeDataCreator.superObjectsData(true) : null;
    }

    return (
      <div className="MainTypes">
        {/* Dropdown for selecting model types */}
        <Dropdown
          title={Config.strings.dropdowns.modelSelection}
          itemsList={Object.values(this.state.aMetaModelTypes)}
          resetThenSet={this.refreshModelTypeSelection}
          disabled={bLoading}
          openedAtCreation={true}
          type={"Model"}
        />
        {(bLoading || (0 === Object.keys(this.state.aSelectedMetaModelTypeData).length) && this.state.aSelectedMetaModelTypeData.sName === "undefined") && <Loader label={Config.strings.dropdowns.loadingSelection} labelDirection={"bottom"}/>}
        {(!bLoading && (0 < Object.keys(this.state.aSelectedMetaModelTypeData).length)) &&
          <div className="MainTypes__container">
            <div className="MainTypes__loopContent">
              {/* Button for insertig models loop */}
              <button className="wrcButton wrcButton--dark" onClick={
                WordInsertions.modelLoop.bind(this,
                  this.state.bSelectedSuperModelType
                    ? null
                    : {
                      sName: this.state.aSelectedMetaModelTypeData.sName,
                    })
              }>
                {
                  this.state.bSelectedSuperModelType
                    ? Config.strings.buttonLabels.loopModels
                    : Config.strings.buttonLabels.loopModelsSpecific.replace(/%s/g, Config.getLangName(this.state.aSelectedMetaModelTypeData))
                }
              </button>

              <div className="MainTypes__sectionBordered">
                {/* Button for inserting model image */}
                <button className="wrcButton" onClick={WordInsertions.modelImage}>
                  {Config.strings.buttonLabels.insertModelGraph}
                </button>
              </div>

              <div className="MainTypes__sectionBordered">
                {/* Tree for inserting single model's property */}
                <AttrTree
                  treeData={aJsonTreeAttrData}
                  dataType="models"
                  isInnerLoop={false}
                  preventRelationNotebook={true}
                />
              </div>

              <div className="MainTypes__sectionBordered">
                {/* Modal for inserting table with model's properties (structure: |property name|property value|) */}
                {aJsonTreeAttrData && Object.hasOwnProperty.call(aJsonTreeAttrData, Config.strings.jsonTree.modelAttributesKey) &&
                  <div>
                    <ModalTableAttrs
                      aNotebook={aJsonTreeAttrData[Config.strings.jsonTree.modelAttributesKey]}
                      sTitle={Config.strings.modals.modelAttrs.sTitle}
                      ref={this.modals.modelAttrs}
                    />
                    <button className="wrcButton wrcButton--secondary wrcButton--secondary_icon" onClick={this.toggleModal.bind(this, 'modelAttrs')}>
                      <img src={tableIcon} height={24}/>
                      {Config.strings.buttonLabels.insertTableModelAttr.replace(/%s/g, Config.getLangName(this.state.aSelectedMetaModelTypeData))}
                    </button>
                  </div>
                }
              </div>

              <div className="MainTypes__sectionBordered">
                {/* Modal for inserting table with model's objects properties (structure: |object name|property1 value|property2 value|... |) */}
                {aJsonTreeObjectsData && Object.hasOwnProperty.call(aJsonTreeObjectsData, Config.strings.jsonTree.objectsKey) &&
                  <div>
                    <ModalTableObjAttrs
                      aItems={this.state.bSelectedSuperModelType ? aJsonTreeObjectsDataSimplified : this.state.aSelectedMetaModelTypeData.classes}
                      sTitle={Config.strings.modals.modelObj.sTitle}
                      sConfirmLabel={Config.strings.modals.modelObj.sConfirmLabel}
                      sRejectLabel={Config.strings.modals.modelObj.sRejectLabel}
                      ref={this.modals.modelObj}
                      isTree={this.state.bSelectedSuperModelType}
                    />
                    <button className="wrcButton wrcButton--secondary wrcButton--secondary_icon" onClick={this.toggleModal.bind(this, 'modelObj')}>
                    <img src={tableIcon} height={24}/>
                      {
                        this.state.bSelectedSuperModelType
                          ? Config.strings.buttonLabels.insertModelObj
                          : Config.strings.buttonLabels.insertModelSpecificObj.replace(/%s/g, Config.getLangName(this.state.aSelectedMetaModelTypeData))
                      }
                    </button>
                  </div>
                }
              </div>

              {/* Modal for inserting loop with selected model's objects */}
              <div className="MainTypes__loopContent">
                <ModalLoopObject
                  aItems={this.state.bSelectedSuperModelType ? aJsonTreeObjectsDataSimplified : this.state.aSelectedMetaModelTypeData.classes}
                  sTitle={Config.strings.modals.modelObjLoop.sTitle}
                  sConfirmLabel={Config.strings.modals.modelObjLoop.sConfirmLabel}
                  sRejectLabel={Config.strings.modals.modelObjLoop.sRejectLabel}
                  ref={this.modals.modelObjLoop}
                  isTree={this.state.bSelectedSuperModelType}
                />
                <button className="wrcButton wrcButton--darkLight" onClick={this.toggleModal.bind(this, 'modelObjLoop')}>
                  {
                    this.state.bSelectedSuperModelType
                      ? Config.strings.buttonLabels.insertModelObjLoop
                      : Config.strings.buttonLabels.insertModelSpecificObjLoop.replace(/%s/g, Config.getLangName(this.state.aSelectedMetaModelTypeData))
                  }
                </button>
              </div>

              {aJsonTreeObjectsData ?
                <div className="MainTypes__loopContent">
                  <ObjectsTree
                    treeData={aJsonTreeObjectsData}
                    isInnerLoop={true}
                    isSingleLvl={true}
                  />
                </div> :
                null
              }

            </div>
          </div>
        }
      </div>
    );
  }
}
